import Api from "@/api/Api";

export default {
  updateAdmin(data) {
    return Api().patch("/admin", data);
  },
};
